import { BoxRendererType } from '@jbrowse/core/pluggableElementTypes'

export default class SvgFeatureRenderer extends BoxRendererType {
  supportsSVG = true
}
